import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RokezzzNotificationService } from 'src/app/rokezzz/notification/services/notification.service';
import { UploadedFile } from '../../file-upload/api/uploaded-file';
import { OnFinish } from '../../api/api/on-finish';
import { RokezzzFileUploaderService } from '../../file-upload/services/file-uploader.service';
import { defaultApiFilterConfig } from '../../api/models/default-api-filter-config';
import { ApiResponse } from '../../api/api/api-response';

@Injectable({
    providedIn: 'root'
})
export class RokezzzImageDataService {
    private imagesSubject: BehaviorSubject<UploadedFile[] | null> = new BehaviorSubject<UploadedFile[] | null>(null);

    public constructor(
        private readonly notificationService: RokezzzNotificationService,
        private readonly rokezzzFileUploaderService: RokezzzFileUploaderService,
    ) { }

    public getIdFromIRI(iri: string): number {
        return this.rokezzzFileUploaderService.getIdFromIRI(iri);
    }

    public getCollection(): BehaviorSubject<UploadedFile[] | null> {
        return this.imagesSubject;
    }

    public get(id: number): UploadedFile | null {
        const images: UploadedFile[] | null = this.imagesSubject.getValue();

        if (images === null) {
            return null;
        }

        return images.find((image: UploadedFile): boolean => image.id === id) || null;
    }

    public isImage(uploadedFile: UploadedFile[] | null): uploadedFile is UploadedFile[] {
        return uploadedFile !== null;
    }

    public refresh(onFinish?: OnFinish<void>): void {
        this.rokezzzFileUploaderService.getCollectionAll(
            defaultApiFilterConfig,
            (response: ApiResponse<UploadedFile>) => {
                this.imagesSubject.next(response.data);
                onFinish?.();
            },
            () => {
                this.notificationService.addServerError();
            }
        );
    }

    public getImageSrc(name: string): string {
        return this.rokezzzFileUploaderService.getImageSrc(name);
    }
}
